import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_dp28ag147e4p5cz as get_dp,
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  get_navExists2s7t7g61yra64 as get_navExists,
  get_windowIsNarrow3aab1t9rdaelq as get_windowIsNarrow,
  get_pwaInstallAvailable261a64jtq77ae as get_pwaInstallAvailable,
  get_dialogStackleaqvayyucjw as get_dialogStack,
} from './crowpay.mjs';
import {
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
  resize3py5p2yrjp6p7 as resize,
  truncate3gvhc1a2is66m as truncate,
  goBackOrReplaceWith1hxiq2flhlluq as goBackOrReplaceWith,
  Action1a4ymn5nx79hk as Action,
  withReverseIndex2csyfnzqm7ypp as withReverseIndex,
} from '../../../utils/utils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { applySafeInsets3lsxkfxcwtdd8 as applySafeInsets } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/safeInsetsHelpers.mjs';
import {
  get_padded3m3frjnjujncx as get_padded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
  Companion_getInstance1350ksylxva5s as Companion_getInstance,
  SelectedSemantic_getInstance3ef29ujazc52t as SelectedSemantic_getInstance,
  plus354lvypr4cqa1 as plus,
  ThemeDerivation3kcl449hwgd5y as ThemeDerivation,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { ImageViewadm9fg4ms58f as ImageView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ImageView.mjs';
import { Resources_getInstance2tvlmekcueurd as Resources_getInstance } from '../../../Resources.js.mjs';
import {
  ImageScaleType_Fit_getInstanceowdhgt1q4kgg as ImageScaleType_Fit_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
  Companion_getInstance3e8hrj2m27b5h as Companion_getInstance_1,
  ImageRemote256pcav1ipbca as ImageRemote,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  hintPopover2584paxgnbc51 as hintPopover,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { UserNotifications_getInstance3eyit5zuwe2sg as UserNotifications_getInstance } from './UserNotifications.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { HasFallback3lthr8mgiugg2 as HasFallback } from '../../screens/common/DialogWithDialog.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  body3i5t0n7zprpqb as body,
} from '../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { MenuButton27en4jjgdkozz as MenuButton } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/MenuButton.commonHtml.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import {
  get_help2Inverse3vh023dds8q8j as get_help2Inverse,
  get_help2pqwxe453785o as get_help2,
  get_profile168kdg11sbepx as get_profile,
  get_install324yslv0fr9jv as get_install,
} from '../../../icons.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  _ServerFile___get_location__impl__ddyqaq3o0wsfuapqiy2 as _ServerFile___get_location__impl__ddyqaq,
  ServerFile1t91jzpzoixwe as ServerFile,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import {
  InitialIconSemantic_getInstanceaqd9z1nvlka3 as InitialIconSemantic_getInstance,
  RemoveOutline_getInstance2r2ekg5cxorga as RemoveOutline_getInstance,
  TestServerSemantic_getInstance3job4xjohh5n6 as TestServerSemantic_getInstance,
} from '../../theming/appTheme.mjs';
import {
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
  get_sessionToken1e5yonv6d457l as get_sessionToken,
  get_session9cytjmfbg8nd as get_session,
} from '../../../sdk/UserSession.mjs';
import { take9j4462mea726 as take } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { get_fullName2ompl3bj5l3sh as get_fullName } from '../../../../../../crowpay-shared/com/crowpay/extensions/User.ext.shared.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from './AppDimensions.mjs';
import {
  get_compact3lsezez8nz8b6 as get_compact,
  get_bold1rri6ahk98puv as get_bold,
  dynamicThemexp3sdnaolntz as dynamicTheme,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  MemberRole_Admin_getInstance3iiznt2spfc6m as MemberRole_Admin_getInstance,
  MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance,
  UserRole_SuperUser_getInstance1w3wkwxya5y4x as UserRole_SuperUser_getInstance,
  ReportType_Daily_getInstance2m8pj9vse9q1l as ReportType_Daily_getInstance,
  ReportType_Weekly_getInstance1l6q95r0n14c5 as ReportType_Weekly_getInstance,
  ReportType_Monthly_getInstanceko04wms5avlp as ReportType_Monthly_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { contains2gm06f5aa19ov as contains } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_2 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  specCenteredContent3evlhhbrk2e00 as specCenteredContent,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../../theming/buttons.mjs';
import {
  get_selectedApi2skzkr2pn0lot as get_selectedApi,
  getDefaultServerBackend2jor6mvf4ze21 as getDefaultServerBackend,
  ApiOption_Production_getInstanceca14cdl7io88 as ApiOption_Production_getInstance,
} from '../../../sdk/apiOptions.mjs';
import { text1v7b2bj2gx49v as text } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../theming/separators.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { get_mostRecentNavSelectionqndzighpm5wa as get_mostRecentNavSelection } from './navigation.mjs';
import { get_selectedContractor2m4vxuqdzv6k3 as get_selectedContractor } from '../../../selectedContractor.mjs';
import {
  awaitqeg6zusi9ora as await_0,
  await1kke5zj2piplv as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { ContractorDashboardpd20b7ol1l5h as ContractorDashboard } from '../../screens/contractor/ContractorDashboard.mjs';
import { ClientDashboard2uxyaz2oxv2st as ClientDashboard } from '../../screens/client/ClientDashboard.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { confirmationDialog1lynowl7yd4cd as confirmationDialog } from '../../dialogs/GenericConfirmationDialog.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { closePopovers89geeulkriez as closePopovers } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewContextExtensions.mjs';
import { HelpDialog1lwp0zwjcf7tt as HelpDialog } from '../../dialogs/HelpDialog.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { GenericDialog2kroovzplfo3s as GenericDialog } from '../../dialogs/GenericDialog.mjs';
import { UserProfile2tyxfth4oycef as UserProfile } from '../../screens/auth/UserProfile.mjs';
import { ContractorProfilenrafjpe3uo0b as ContractorProfile } from '../../screens/contractor/ContractorProfile.mjs';
import { ContractorBankInfo3chkr569ztcs7 as ContractorBankInfo } from '../../screens/contractor/ContractorBankInfo.mjs';
import { ContractorBillingInfos14ebalmoocx as ContractorBillingInfo } from '../../screens/contractor/ContractorBillingInfo.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { LogInScreen3qovz4fzwtjwv as LogInScreen } from '../../screens/auth/LogInScreen.mjs';
import { pwaInstallPrompt2aaai8ml9vmh3 as pwaInstallPrompt } from '../../../actuals/pwaCheck.js.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function crowpayNavHeaderWide(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var $this$col = view;
  $this$col.zb8(get_dp(0));
  shownDefaultFalse($this$col, ($this$shownDefaultFalse) => $this$shownDefaultFalse.baj(get_navExists($this$col)));
  applySafeInsets($this$col, VOID, VOID, VOID, false);
  var tmp = get_padded($this$col);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())($this$col.pc());
  var tmp0_elvis_lhs_0 = $this$col.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? $this$col : tmp0_elvis_lhs_0;
  $this$col.ebb(p_0, view_0);
  view_0.xbm(false);
  view_0.zb8(get_rem(1.5));
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp_0 = view_0.hbb(ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Button())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  var tmp_1 = sizeConstraints(view_1, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(2.25));
  // Inline function 'com.lightningkite.kiteui.views.direct.image' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (ImageView())(view_1);
  this_0.oda(Resources_getInstance().vf8_1);
  this_0.pda(ImageScaleType_Fit_getInstance());
  this_0.zba();
  view_1.jbb(tmp_1, this_0);
  onClick(view_1, 'Navigate Home', VOID, crowpayNavHeaderWide$slambda_0(view_1));
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_0, view_1);
  var tmp_2 = get_expanding(view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Space())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_2, view_2);
  view_0.fbb(p_2, view_2);
  view_0.jbb(tmp_2, view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_3 = view_0.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
  view_0.ebb(p_3, view_3);
  view_3.xbm(false);
  view_3.zb8(get_rem(0.5));
  view_3.jbb(view_3.ibb(shownWhen(view_3, VOID, crowpayNavHeaderWide$lambda), get_centered(view_3)), pwaInstall(view_3));
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$11 = view_3.hbb(ButtonSemantic_getInstance());
  view_3.jbb(view_3.ibb(tmp$ret$11, get_centered(view_3)), helpButton(view_3));
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$12 = view_3.hbb(ButtonSemantic_getInstance());
  view_3.jbb(view_3.ibb(tmp$ret$12, get_centered(view_3)), UserNotifications_getInstance().kgg(view_3));
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$13 = view_3.hbb(ButtonSemantic_getInstance());
  view_3.jbb(view_3.ibb(tmp$ret$13, get_centered(view_3)), userButton(view_3));
  view_0.fbb(p_3, view_3);
  $this$col.fbb(p_0, view_0);
  $this$col.jbb(tmp, view_0);
  var tmp_3 = sizeConstraints($this$col, VOID, VOID, VOID, VOID, VOID, VOID, get_dp(2));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (Frame())($this$col.pc());
  var tmp0_elvis_lhs_4 = $this$col.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? $this$col : tmp0_elvis_lhs_4;
  $this$col.ebb(p_4, view_4);
  var tmp_4 = view_4.ob6_1;
  // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
  Companion_getInstance();
  var tmp$ret$22 = new (crowpayNavHeaderWide$$inlined$col$1())();
  view_4.jba(tmp_4.ybe(tmp$ret$22));
  $this$col.fbb(p_4, view_4);
  $this$col.jbb(tmp_3, view_4);
  _this__u8e3s4.fbb(p, view);
  return view;
}
var FormClass;
function Form() {
  if (FormClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Form');
    FormClass = $;
  }
  return FormClass;
}
function crowpayNavHeaderNarrow(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  applySafeInsets(view, VOID, VOID, VOID, false);
  var tmp = get_expanding(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  var $this$row = view_0;
  $this$row.zb8(get_dp(5));
  var tmp_0 = get_centered($this$row);
  var tmp_1 = $this$row.ibb(tmp_0, shownWhen($this$row, VOID, ($this$shownWhen) => {
    var tmp;
    if ($this$shownWhen.baj(get_mainPageNavigator($this$row).ibn_1)) {
      tmp = true;
    } else {
      var tmp_0 = $this$shownWhen.baj(get_mainPageNavigator($this$row).hbn_1);
      tmp = !(tmp_0 == null) ? isInterface(tmp_0, HasFallback()) : false;
    }
    return tmp;
  }));
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$0 = $this$row.hbb(ButtonSemantic_getInstance());
  var tmp_2 = $this$row.ibb(tmp_1, tmp$ret$0);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Button())($this$row.pc());
  var tmp0_elvis_lhs_1 = $this$row.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? $this$row : tmp0_elvis_lhs_1;
  $this$row.ebb(p_1, view_1);
  icon(view_1, resize(Companion_getInstance_0().ycf_1, get_rem(1.25)), 'arrow back');
  onClick(view_1, 'Go Back', VOID, crowpayNavHeaderNarrow$slambda_0(view_1));
  $this$row.fbb(p_1, view_1);
  $this$row.jbb(tmp_2, view_1);
  var tmp_3 = $this$row.ibb(get_expanding($this$row), get_centered($this$row));
  // Inline function 'com.crowpay.views.theming.boldSubTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())($this$row.pc());
  var tmp0_elvis_lhs_2 = $this$row.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? $this$row : tmp0_elvis_lhs_2;
  $this$row.ebb(p_2, view_2);
  view_2.jba(view_2.ob6_1.ybe(SubtitleSemantic_getInstance().ybe(BoldSemantic_getInstance())));
  var $this$boldSubTitle = view_2;
  $this$boldSubTitle.yco(false);
  $this$boldSubTitle.xco(true);
  var tmp_4 = KMutableProperty0();
  var tmp_5 = TextView$_get_content_$ref_4pzcwl($this$boldSubTitle);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb($this$boldSubTitle));
  reactiveScope($this$boldSubTitle, ($this$reactiveScope) => {
    var tmp0_safe_receiver = $this$reactiveScope.baj(get_mainPageNavigator($this$boldSubTitle).hbn_1);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ucv();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : $this$reactiveScope.baj(tmp1_safe_receiver);
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : truncate(tmp2_safe_receiver, 20);
    var tmp$ret$4 = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
    this_0.set(tmp$ret$4);
    return Unit_instance;
  });
  $this$row.fbb(p_2, view_2);
  $this$row.jbb(tmp_3, view_2);
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_3 = view.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.ebb(p_3, view_3);
  view_3.xbm(false);
  view_3.zb8(get_rem(0.5));
  var tmp_6 = shownWhen(view_3, VOID, crowpayNavHeaderNarrow$lambda);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$15 = view_3.hbb(ButtonSemantic_getInstance());
  view_3.jbb(view_3.ibb(view_3.ibb(tmp_6, tmp$ret$15), get_centered(view_3)), pwaInstall(view_3));
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$16 = view_3.hbb(ButtonSemantic_getInstance());
  view_3.jbb(view_3.ibb(tmp$ret$16, get_centered(view_3)), helpButton(view_3));
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$17 = view_3.hbb(ButtonSemantic_getInstance());
  view_3.jbb(view_3.ibb(tmp$ret$17, get_centered(view_3)), userButton(view_3));
  view.fbb(p_3, view_3);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function helpButton(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (MenuButton())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.yc3_1 = true;
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (IconView())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var tmp = KMutableProperty0();
  var tmp_0 = IconView$_get_source_$ref_hlcyij(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('source', 0, tmp, tmp_0, IconView$_set_source_$ref_2j4ddb(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    var tmp$ret$0 = $this$reactiveScope.baj(get_windowIsNarrow()) ? resize(get_help2(Companion_getInstance_0()), get_rem(1.3)) : resize(get_help2Inverse(Companion_getInstance_0()), get_rem_0(2));
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  view_0.ebu('Help');
  view.fbb(p_0, view_0);
  view.ec4(helpButton$lambda);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function userButton(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (MenuButton())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.bc4(Companion_getInstance_1().ycq_1);
  view.yc3_1 = true;
  var membership = remember(VOID, VOID, VOID, userButton$lambda);
  var contractor = remember(VOID, VOID, VOID, userButton$lambda_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  var tmp0_height = get_rem_0(2);
  var tmp1_width = get_rem_0(2);
  var tmp = view_0.ibb(sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, tmp1_width, tmp0_height), get_centered(view_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.image' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (ImageView())(view_0);
  shownDefaultFalse(this_0.ada_1, ($this$shownDefaultFalse) => {
    var tmp;
    if (!($this$shownDefaultFalse.baj(contractor) == null)) {
      var tmp0_safe_receiver = $this$shownDefaultFalse.baj(contractor);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c5j_1;
      var tmp_0;
      var tmp_1 = tmp1_safe_receiver;
      if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
        tmp_0 = null;
      } else {
        tmp_0 = _ServerFile___get_location__impl__ddyqaq(tmp1_safe_receiver);
      }
      var tmp2_safe_receiver = tmp_0;
      var tmp_2;
      if (tmp2_safe_receiver == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.text.isNotBlank' call
        tmp_2 = !isBlank(tmp2_safe_receiver);
      }
      tmp = tmp_2 === true;
    } else {
      tmp = false;
    }
    return tmp;
  });
  var tmp_0 = KMutableProperty0();
  var tmp_1 = ImageView$_get_source_$ref_ain7z1(this_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('source', 0, tmp_0, tmp_1, ImageView$_set_source_$ref_4jld67(this_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    var tmp0_safe_receiver = $this$reactiveScope.baj(contractor);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c5j_1;
    var tmp;
    var tmp_0 = tmp1_safe_receiver;
    if ((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = _ServerFile___get_location__impl__ddyqaq(tmp1_safe_receiver);
    }
    var tmp2_safe_receiver = tmp;
    var tmp_1;
    if (tmp2_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.takeUnless' call
      var tmp_2;
      if (!isBlank(tmp2_safe_receiver)) {
        tmp_2 = tmp2_safe_receiver;
      } else {
        tmp_2 = null;
      }
      tmp_1 = tmp_2;
    }
    var tmp3_safe_receiver = tmp_1;
    var tmp_3;
    if (tmp3_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_3 = new (ImageRemote())(tmp3_safe_receiver);
    }
    var tmp4_elvis_lhs = tmp_3;
    var tmp$ret$5 = tmp4_elvis_lhs == null ? get_profile(Companion_getInstance_0()).ed5(AppColors_getInstance().cfz_1.xg9_1) : tmp4_elvis_lhs;
    this_1.set(tmp$ret$5);
    return Unit_instance;
  });
  this_0.ebu('Switch Profile');
  this_0.zba();
  view_0.jbb(tmp, this_0);
  var tmp_2 = view_0.ibb(view_0.ibb(get_centered(view_0), sizeConstraints(view_0, VOID, VOID, VOID, VOID, 1.0)), view_0.hbb(InitialIconSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Frame())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  shownDefaultFalse(view_1, ($this$shownDefaultFalse) => {
    var tmp;
    if ($this$shownDefaultFalse.baj(contractor) == null) {
      tmp = true;
    } else {
      var tmp0_safe_receiver = $this$shownDefaultFalse.baj(contractor);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c5j_1;
      var tmp_0;
      var tmp_1 = tmp1_safe_receiver;
      if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
        tmp_0 = null;
      } else {
        tmp_0 = _ServerFile___get_location__impl__ddyqaq(tmp1_safe_receiver);
      }
      // Inline function 'kotlin.text.isNullOrBlank' call
      var this_0 = tmp_0;
      tmp = this_0 == null || isBlank(this_0);
    }
    return tmp;
  });
  var tmp_3 = get_centered(view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  view_2.bbs(Align_Center_getInstance());
  var tmp_4 = KMutableProperty0();
  var tmp_5 = TextView$_get_content_$ref_4pzcwl_0(view_2);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_0(view_2));
  reactiveScope(view_2, ($this$reactiveScope) => {
    // Inline function 'kotlin.let' call
    var it = $this$reactiveScope.baj($this$reactiveScope.caj(get_rawSession()).pfw_1);
    var tmp$ret$14 = take(it.j88_1, 1) + take(it.k88_1, 1);
    this_2.set(tmp$ret$14);
    return Unit_instance;
  });
  view_1.fbb(p_2, view_2);
  view_1.jbb(tmp_3, view_2);
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_2, view_1);
  var tmp_6 = get_centered(view_0);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_3 = view_0.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
  view_0.ebb(p_3, view_3);
  view_3.jba(view_3.ob6_1.ybe(SubtitleSemantic_getInstance()));
  view_3.bbs(Align_Center_getInstance());
  var tmp_7 = KMutableProperty0();
  var tmp_8 = TextView$_get_content_$ref_4pzcwl_1(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb_1(view_3));
  reactiveScope(view_3, ($this$reactiveScope) => {
    var isNarrow = $this$reactiveScope.baj(get_windowIsNarrow());
    var tmp0_safe_receiver = $this$reactiveScope.baj(contractor);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x5i_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : take(tmp1_safe_receiver, isNarrow ? 10 : 20);
    var tmp;
    if (tmp2_elvis_lhs == null) {
      var tmp_0;
      if (isNarrow) {
        tmp_0 = '';
      } else {
        var tmp3_safe_receiver = $this$reactiveScope.baj(get_rawSession());
        var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.pfw_1;
        var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : $this$reactiveScope.baj(tmp4_safe_receiver);
        var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : get_fullName(tmp5_safe_receiver);
        tmp_0 = tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    var tmp$ret$22 = tmp;
    this_3.set(tmp$ret$22);
    return Unit_instance;
  });
  view_0.fbb(p_3, view_3);
  view_0.jbb(tmp_6, view_3);
  view.fbb(p_0, view_0);
  view.ec4(($this$opensMenu) => {
    var tmp = sizeConstraints($this$opensMenu, get_AppDimensions().dg2_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$opensMenu.pc());
    var tmp0_elvis_lhs = $this$opensMenu.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$opensMenu : tmp0_elvis_lhs;
    $this$opensMenu.ebb(p, view);
    view.xbm(true);
    var tmp_0 = get_compact(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.xbm(true);
    // Inline function 'com.crowpay.views.theming.subTitle' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    view_1.jba(view_1.ob6_1.ybe(SubtitleSemantic_getInstance()));
    view_1.bbs(Align_Center_getInstance());
    var tmp_1 = KMutableProperty0();
    var tmp_2 = TextView$_get_content_$ref_4pzcwl_2(view_1);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_2(view_1));
    reactiveScope(view_1, ($this$reactiveScope) => {
      var tmp0_safe_receiver = $this$reactiveScope.baj(get_rawSession());
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pfw_1;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : $this$reactiveScope.baj(tmp1_safe_receiver);
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : get_fullName(tmp2_safe_receiver);
      var tmp$ret$33 = tmp3_elvis_lhs == null ? 'Not Logged In' : tmp3_elvis_lhs;
      this_0.set(tmp$ret$33);
      return Unit_instance;
    });
    view_0.fbb(p_1, view_1);
    // Inline function 'com.crowpay.views.theming.smallBody' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_2 = view_0.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
    view_0.ebb(p_2, view_2);
    view_2.jba(view_2.ob6_1.ybe(SmallBodySemantic_getInstance()));
    shownDefaultFalse(view_2, ($this$shownDefaultFalse) => !($this$shownDefaultFalse.baj(contractor) == null));
    view_2.bbs(Align_Center_getInstance());
    var tmp_3 = KMutableProperty0();
    var tmp_4 = TextView$_get_content_$ref_4pzcwl_3(view_2);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb_3(view_2));
    reactiveScope(view_2, ($this$reactiveScope) => {
      var tmp0_safe_receiver = $this$reactiveScope.baj(contractor);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x5i_1;
      var tmp$ret$40 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
      this_1.set(tmp$ret$40);
      return Unit_instance;
    });
    view_0.fbb(p_2, view_2);
    view.fbb(p_0, view_0);
    view.jbb(tmp_0, view_0);
    var tmp_5 = view.hbb(RemoveOutline_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_3 = view.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
    view.ebb(p_3, view_3);
    view_3.xbm(true);
    view_3.zb8(get_dp(0));
    userButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$navlink_xbnl6i(view_3, 'User Profile', userButton$lambda$lambda);
    var tmp_6 = shownWhen(view_3, VOID, ($this$shownWhen) => {
      var tmp;
      if (!($this$shownWhen.baj(contractor) == null)) {
        var tmp_0 = setOf([MemberRole_Admin_getInstance(), MemberRole_Manager_getInstance()]);
        var tmp0_safe_receiver = $this$shownWhen.baj(membership);
        tmp = contains(tmp_0, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j8c_1);
      } else {
        tmp = false;
      }
      return tmp;
    });
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (RowOrCol())(view_3.pc());
    var tmp0_elvis_lhs_4 = view_3.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
    view_3.ebb(p_4, view_4);
    view_4.xbm(true);
    view_4.zb8(get_dp(0));
    userButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$navlink_xbnl6i(view_4, 'Business Info', userButton$lambda$lambda_0);
    shownWhen(view_4, VOID, ($this$shownWhen) => {
      var tmp0_safe_receiver = $this$shownWhen.baj(membership);
      return equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j8c_1, MemberRole_Admin_getInstance());
    });
    userButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$navlink_xbnl6i(view_4, 'Bank Info', userButton$lambda$lambda_1);
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
    Companion_getInstance_2();
    userButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$navlink_xbnl6i(view_4, 'Billing', userButton$lambda$lambda_2);
    view_3.fbb(p_4, view_4);
    view_3.jbb(tmp_6, view_4);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (Button())(view_3.pc());
    var tmp0_elvis_lhs_5 = view_3.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
    view_3.ebb(p_5, view_5);
    specCenteredContent(view_5, VOID, userButton$lambda$lambda_3);
    onClick(view_5, VOID, VOID, userButton$lambda$slambda_0(view_5));
    view_3.fbb(p_5, view_5);
    var tmp_7 = view_3.ibb(shownWhen(view_3, VOID, userButton$lambda$lambda_4), view_3.hbb(TestServerSemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (Frame())(view_3.pc());
    var tmp0_elvis_lhs_6 = view_3.cbb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view_3 : tmp0_elvis_lhs_6;
    view_3.ebb(p_6, view_6);
    var tmp_8 = get_centered(view_6);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (TextView())(view_6.pc());
    var tmp0_elvis_lhs_7 = view_6.cbb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
    view_6.ebb(p_7, view_7);
    var tmp_9 = KMutableProperty0();
    var tmp_10 = TextView$_get_content_$ref_4pzcwl_4(view_7);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_2 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb_4(view_7));
    reactiveScope(view_7, ($this$reactiveScope) => {
      var tmp;
      if (getDefaultServerBackend().equals(ApiOption_Production_getInstance())) {
        tmp = 'Using Test Server ' + $this$reactiveScope.baj(get_selectedApi()).a4_1;
      } else {
        tmp = 'Using Server ' + $this$reactiveScope.baj(get_selectedApi()).a4_1;
      }
      var tmp$ret$59 = tmp;
      this_2.set(tmp$ret$59);
      return Unit_instance;
    });
    view_6.fbb(p_7, view_7);
    view_6.jbb(tmp_8, view_7);
    view_3.fbb(p_6, view_6);
    view_3.jbb(tmp_7, view_6);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_8 = new (Space())(view_3.pc());
    var tmp0_elvis_lhs_8 = view_3.cbb_1;
    var p_8 = tmp0_elvis_lhs_8 == null ? view_3 : tmp0_elvis_lhs_8;
    view_3.ebb(p_8, view_8);
    view_3.fbb(p_8, view_8);
    var tmp_11 = shownWhen(view_3, VOID, userButton$lambda$lambda_5);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_9 = new (RowOrCol())(view_3.pc());
    var tmp0_elvis_lhs_9 = view_3.cbb_1;
    var p_9 = tmp0_elvis_lhs_9 == null ? view_3 : tmp0_elvis_lhs_9;
    view_3.ebb(p_9, view_9);
    view_9.xbm(true);
    view_9.zb8(get_dp(0));
    view_9.jbb(view_9.ibb(get_bold(view_9), get_padded(view_9)), text(view_9, 'Admin Test Actions'));
    greySeparator(view_9);
    userButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$navAction_v98zoq(view_9, 'Refresh Project Timers', userButton$lambda$slambda_2());
    userButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$navAction_v98zoq(view_9, 'Trigger Daily Report', userButton$lambda$slambda_4());
    userButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$navAction_v98zoq(view_9, 'Trigger Weekly Report', userButton$lambda$slambda_6());
    userButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$navAction_v98zoq(view_9, 'Trigger Monthly Report', userButton$lambda$slambda_8());
    userButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$navAction_v98zoq(view_9, 'Trigger Payment Checks', userButton$lambda$slambda_10());
    view_3.fbb(p_9, view_9);
    view_3.jbb(tmp_11, view_9);
    view.fbb(p_3, view_3);
    view.jbb(tmp_5, view_3);
    $this$opensMenu.fbb(p, view);
    $this$opensMenu.jbb(tmp, view);
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
  return view;
}
function pwaInstall(_this__u8e3s4) {
  var tmp = Companion_getInstance_1().zcq_1;
  var tmp_0 = hintPopover(_this__u8e3s4, tmp, pwaInstall$lambda);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$0 = _this__u8e3s4.hbb(ButtonSemantic_getInstance());
  var tmp_1 = _this__u8e3s4.ibb(tmp_0, tmp$ret$0);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.jbb(get_centered(view), icon(view, get_install(Companion_getInstance_0()), 'Install This Site'));
  onClick(view, VOID, VOID, pwaInstall$slambda_0());
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp_1, view);
}
function crowpayNavHeaderNarrow$_anonymous_$_anonymous_$_anonymous_$_anonymous_$goBack_8lqrkl(current, $this_button) {
  var tmp;
  if (!(current == null) ? isInterface(current, HasFallback()) : false) {
    var tmp_0 = get_mainPageNavigator($this_button);
    goBackOrReplaceWith(tmp_0, () => {
      // Inline function 'kotlin.run' call
      return current.cgh($this_button);
    });
    tmp = Unit_instance;
  } else {
    tmp = get_mainPageNavigator($this_button).qd6();
  }
  return tmp;
}
function userButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$navlink_xbnl6i(_this__u8e3s4, name, to) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_dp(0));
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp = view.hbb(ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Link())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  body(view_0, name);
  dynamicTheme(view_0, ($this$dynamicTheme) => $this$dynamicTheme.baj(get_mostRecentNavSelection()) === name ? SelectedSemantic_getInstance() : null);
  view_0.tbw(userButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$navlink$slambda_fsshu8_0(name, view_0));
  view_0.ibw(to);
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  greySeparator(view);
  _this__u8e3s4.fbb(p, view);
}
function userButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$navAction_v98zoq(_this__u8e3s4, name, action) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_dp(0));
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp = view.hbb(ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Button())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  body(view_0, name);
  dynamicTheme(view_0, ($this$dynamicTheme) => $this$dynamicTheme.baj(get_mostRecentNavSelection()) === name ? SelectedSemantic_getInstance() : null);
  onClick(view_0, VOID, VOID, action);
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  greySeparator(view);
  _this__u8e3s4.fbb(p, view);
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = get_mainPageNavigator($this.dgh_1);
  var tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_selectedContractor();
  var tmp_1 = await_0(this_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  if (tmp_1 == null) {
    tmp_0 = new (ClientDashboard())();
  } else {
    tmp_0 = new (ContractorDashboard())();
  }
  tmp.dbw(tmp_0);
  return Unit_instance;
}
var crowpayNavHeaderWide$slambdaClass;
function crowpayNavHeaderWide$slambda() {
  if (crowpayNavHeaderWide$slambdaClass === VOID) {
    class $ {
      constructor($$this$button) {
        this.dgh_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    crowpayNavHeaderWide$slambdaClass = $;
  }
  return crowpayNavHeaderWide$slambdaClass;
}
function crowpayNavHeaderWide$slambda_0($$this$button) {
  var i = new (crowpayNavHeaderWide$slambda())($$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function crowpayNavHeaderWide$lambda($this$shownWhen) {
  return $this$shownWhen.baj(get_pwaInstallAvailable());
}
var crowpayNavHeaderWide$$inlined$col$1Class;
function crowpayNavHeaderWide$$inlined$col$1() {
  if (crowpayNavHeaderWide$$inlined$col$1Class === VOID) {
    class $ {
      fd1(theme) {
        return theme.ud1('grnline', VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().dfz_1.xg9_1).zb0_1;
      }
    }
    protoOf($).ybe = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    crowpayNavHeaderWide$$inlined$col$1Class = $;
  }
  return crowpayNavHeaderWide$$inlined$col$1Class;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_mainPageNavigator($this.egh_1).hbn_1;
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var current = tmp;
  var tmp_0;
  if (!(current == null) ? isInterface(current, Form()) : false) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = current.ug9();
    var tmp_1 = await_1(this_1, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = !tmp_1;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    confirmationDialog($this.egh_1, 'Discard Changes', 'This page has unsaved changes, exiting will lose this information. Are you sure you want to do this?', 'Discard and Exit', VOID, VOID, VOID, VOID, VOID, VOID, crowpayNavHeaderNarrow$slambda$slambda_0(current, $this.egh_1));
  } else {
    crowpayNavHeaderNarrow$_anonymous_$_anonymous_$_anonymous_$_anonymous_$goBack_8lqrkl(current, $this.egh_1);
  }
  return Unit_instance;
}
var crowpayNavHeaderNarrow$slambda$slambdaClass;
function crowpayNavHeaderNarrow$slambda$slambda() {
  if (crowpayNavHeaderNarrow$slambda$slambdaClass === VOID) {
    class $ {
      constructor($current, $$this$button) {
        this.fgh_1 = $current;
        this.ggh_1 = $$this$button;
      }
      sao($completion) {
        crowpayNavHeaderNarrow$_anonymous_$_anonymous_$_anonymous_$_anonymous_$goBack_8lqrkl(this.fgh_1, this.ggh_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    crowpayNavHeaderNarrow$slambda$slambdaClass = $;
  }
  return crowpayNavHeaderNarrow$slambda$slambdaClass;
}
function crowpayNavHeaderNarrow$slambda$slambda_0($current, $$this$button) {
  var i = new (crowpayNavHeaderNarrow$slambda$slambda())($current, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var crowpayNavHeaderNarrow$slambdaClass;
function crowpayNavHeaderNarrow$slambda() {
  if (crowpayNavHeaderNarrow$slambdaClass === VOID) {
    class $ {
      constructor($$this$button) {
        this.egh_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    crowpayNavHeaderNarrow$slambdaClass = $;
  }
  return crowpayNavHeaderNarrow$slambdaClass;
}
function crowpayNavHeaderNarrow$slambda_0($$this$button) {
  var i = new (crowpayNavHeaderNarrow$slambda())($$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function crowpayNavHeaderNarrow$lambda($this$shownWhen) {
  return $this$shownWhen.baj(get_pwaInstallAvailable());
}
function IconView$_get_source_$ref_hlcyij(p0) {
  return () => p0.obt_1;
}
function IconView$_set_source_$ref_2j4ddb(p0) {
  return (_this__u8e3s4) => {
    p0.qbt(_this__u8e3s4);
    return Unit_instance;
  };
}
function helpButton$lambda($this$opensMenu) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$opensMenu.pc());
  var tmp0_elvis_lhs = $this$opensMenu.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$opensMenu : tmp0_elvis_lhs;
  $this$opensMenu.ebb(p, view);
  view.xbm(true);
  view.zb8(get_rem_0(0));
  var tmp = Action('Contact Stoze', VOID, helpButton$lambda$slambda_0(view));
  var options = listOf([tmp, Action('Support Library', VOID, helpButton$lambda$slambda_2(view))]);
  var _iterator__ex2g4s = withReverseIndex(options).m1();
  while (_iterator__ex2g4s.n1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.o1();
    var idx = _destruct__k2r9zo.cf();
    var option = _destruct__k2r9zo.df();
    var tmp_0 = get_compact(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Button())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    specCenteredText(view_0, option.ucv());
    view_0.mbg(option);
    view.fbb(p_0, view_0);
    view.jbb(tmp_0, view_0);
    if (!(idx === 0)) {
      greySeparator(view);
    }
  }
  $this$opensMenu.fbb(p, view);
  return Unit_instance;
}
var helpButton$lambda$slambdaClass;
function helpButton$lambda$slambda() {
  if (helpButton$lambda$slambdaClass === VOID) {
    class $ {
      constructor($$this$col) {
        this.hgh_1 = $$this$col;
      }
      wah($this$Action, $completion) {
        closePopovers(this.hgh_1);
        get_dialogStack().xgd(new (HelpDialog())());
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    helpButton$lambda$slambdaClass = $;
  }
  return helpButton$lambda$slambdaClass;
}
function helpButton$lambda$slambda_0($$this$col) {
  var i = new (helpButton$lambda$slambda())($$this$col);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
var helpButton$lambda$slambdaClass_0;
function helpButton$lambda$slambda_1() {
  if (helpButton$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$col) {
        this.igh_1 = $$this$col;
      }
      wah($this$Action, $completion) {
        closePopovers(this.igh_1);
        get_dialogStack().xgd(GenericDialog().bgh('Support', 'Support library is coming soon, stay tuned for updates!'));
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    helpButton$lambda$slambdaClass_0 = $;
  }
  return helpButton$lambda$slambdaClass_0;
}
function helpButton$lambda$slambda_2($$this$col) {
  var i = new (helpButton$lambda$slambda_1())($$this$col);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function userButton$lambda($this$remember) {
  var tmp0_safe_receiver = $this$remember.baj(get_rawSession());
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$remember.baj(tmp0_safe_receiver.pfw_1);
  return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.m88_1;
}
function userButton$lambda_0($this$remember) {
  var tmp0_elvis_lhs = $this$remember.baj(get_rawSession());
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var session = tmp;
  var tmp1_elvis_lhs = $this$remember.baj(session.pfw_1).m88_1;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var ship = tmp_0;
  return $this$remember.baj(session.jfv_1.eeo(ship.i8c_1));
}
function ImageView$_get_source_$ref_ain7z1(p0) {
  return () => p0.i2i();
}
function ImageView$_set_source_$ref_4jld67(p0) {
  return (_this__u8e3s4) => {
    p0.oda(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function userButton$lambda$lambda() {
  return new (UserProfile())();
}
function userButton$lambda$lambda_0() {
  return new (ContractorProfile())();
}
function userButton$lambda$lambda_1() {
  return new (ContractorBankInfo())();
}
function userButton$lambda$lambda_2() {
  return new (ContractorBillingInfo())();
}
function userButton$lambda$lambda_3($this$specCenteredContent) {
  var tmp = get_compact($this$specCenteredContent);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$specCenteredContent.pc());
  var tmp0_elvis_lhs = $this$specCenteredContent.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$specCenteredContent : tmp0_elvis_lhs;
  $this$specCenteredContent.ebb(p, view);
  view.xbm(false);
  view.jbb(get_centered(view), icon(view, resize(Companion_getInstance_0().bcg_1, get_rem(1.2)), 'log out'));
  view.jbb(get_centered(view), body(view, 'Log Out'));
  $this$specCenteredContent.fbb(p, view);
  return $this$specCenteredContent.jbb(tmp, view);
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  try {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_rawSession();
    var tmp = await_1(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp0_safe_receiver = tmp;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tfw();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.bfh_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      var tmp_0 = tmp2_safe_receiver.zei($completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
    }
  } catch ($p) {
    if ($p instanceof Exception()) {
      var _unused_var__etf5q3 = $p;
    } else {
      throw $p;
    }
  }
  var tmp_1 = get_sessionToken().gah(null, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  get_mainPageNavigator($this.jgh_1).ebw(new (LogInScreen())());
  return Unit_instance;
}
var userButton$lambda$slambda$slambdaClass;
function userButton$lambda$slambda$slambda() {
  if (userButton$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($$this$button) {
        this.jgh_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    userButton$lambda$slambda$slambdaClass = $;
  }
  return userButton$lambda$slambda$slambdaClass;
}
function userButton$lambda$slambda$slambda_0($$this$button) {
  var i = new (userButton$lambda$slambda$slambda())($$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var userButton$lambda$slambdaClass;
function userButton$lambda$slambda() {
  if (userButton$lambda$slambdaClass === VOID) {
    class $ {
      constructor($$this$button) {
        this.kgh_1 = $$this$button;
      }
      sao($completion) {
        closePopovers(this.kgh_1);
        confirmationDialog(this.kgh_1, 'Log Out?', 'Are you sure you want to log out?', 'Log Out', VOID, VOID, VOID, VOID, VOID, VOID, userButton$lambda$slambda$slambda_0(this.kgh_1));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    userButton$lambda$slambdaClass = $;
  }
  return userButton$lambda$slambdaClass;
}
function userButton$lambda$slambda_0($$this$button) {
  var i = new (userButton$lambda$slambda())($$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function userButton$lambda$lambda_4($this$shownWhen) {
  return !$this$shownWhen.baj(get_selectedApi()).equals(getDefaultServerBackend());
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function userButton$lambda$lambda_5($this$shownWhen) {
  return $this$shownWhen.baj(get_selectedApi()).afx_1 && $this$shownWhen.baj($this$shownWhen.baj(get_session()).pfw_1).o88_1.equals(UserRole_SuperUser_getInstance());
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfw().tfg_1.lfq($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var userButton$lambda$slambdaClass_0;
function userButton$lambda$slambda_1() {
  if (userButton$lambda$slambdaClass_0 === VOID) {
    class $ {
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    userButton$lambda$slambdaClass_0 = $;
  }
  return userButton$lambda$slambdaClass_0;
}
function userButton$lambda$slambda_2() {
  var i = new (userButton$lambda$slambda_1())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfw().qff_1.rfj(ReportType_Daily_getInstance(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var userButton$lambda$slambdaClass_1;
function userButton$lambda$slambda_3() {
  if (userButton$lambda$slambdaClass_1 === VOID) {
    class $ {
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    userButton$lambda$slambdaClass_1 = $;
  }
  return userButton$lambda$slambdaClass_1;
}
function userButton$lambda$slambda_4() {
  var i = new (userButton$lambda$slambda_3())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfw().qff_1.rfj(ReportType_Weekly_getInstance(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var userButton$lambda$slambdaClass_2;
function userButton$lambda$slambda_5() {
  if (userButton$lambda$slambdaClass_2 === VOID) {
    class $ {
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    userButton$lambda$slambdaClass_2 = $;
  }
  return userButton$lambda$slambdaClass_2;
}
function userButton$lambda$slambda_6() {
  var i = new (userButton$lambda$slambda_5())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfw().qff_1.rfj(ReportType_Monthly_getInstance(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var userButton$lambda$slambdaClass_3;
function userButton$lambda$slambda_7() {
  if (userButton$lambda$slambdaClass_3 === VOID) {
    class $ {
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    userButton$lambda$slambdaClass_3 = $;
  }
  return userButton$lambda$slambdaClass_3;
}
function userButton$lambda$slambda_8() {
  var i = new (userButton$lambda$slambda_7())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfw().qff_1.qfj('checkTransactionUpdates', $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var userButton$lambda$slambdaClass_4;
function userButton$lambda$slambda_9() {
  if (userButton$lambda$slambdaClass_4 === VOID) {
    class $ {
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    userButton$lambda$slambdaClass_4 = $;
  }
  return userButton$lambda$slambdaClass_4;
}
function userButton$lambda$slambda_10() {
  var i = new (userButton$lambda$slambda_9())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function pwaInstall$lambda($this$hintPopover) {
  text($this$hintPopover, 'Install This Site');
  return Unit_instance;
}
var pwaInstall$slambdaClass;
function pwaInstall$slambda() {
  if (pwaInstall$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        pwaInstallPrompt();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    pwaInstall$slambdaClass = $;
  }
  return pwaInstall$slambdaClass;
}
function pwaInstall$slambda_0() {
  var i = new (pwaInstall$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var userButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$navlink$slambda_fsshu8Class;
function userButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$navlink$slambda_fsshu8() {
  if (userButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$navlink$slambda_fsshu8Class === VOID) {
    class $ {
      constructor($name, $$this$link) {
        this.lgh_1 = $name;
        this.mgh_1 = $$this$link;
      }
      sao($completion) {
        get_mostRecentNavSelection().mam(this.lgh_1);
        closePopovers(this.mgh_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    userButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$navlink$slambda_fsshu8Class = $;
  }
  return userButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$navlink$slambda_fsshu8Class;
}
function userButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$navlink$slambda_fsshu8_0($name, $$this$link) {
  var i = new (userButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$navlink$slambda_fsshu8())($name, $$this$link);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  Form as Form39thjb3imm7id,
  crowpayNavHeaderNarrow as crowpayNavHeaderNarrow3nv75bwx6kil4,
  crowpayNavHeaderWide as crowpayNavHeaderWide309ruo66u7u86,
};
//endregion

//# sourceMappingURL=header.mjs.map
